var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.item.users),function(user,index){return _c('User',{key:index,attrs:{"user":user}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }